<header class="shadow rounded bg-light">
  <div class="row">
    <div class="col">
      <img
        [ngSrc]="logo"
        class="img-fluid"
        alt="AK header logo picture"
        height="123"
        width="190"
      />
    </div>
    <div class="col-8 text-center">
      <h1 class="fw-bold">
        Online Application for AK HIPP -
        <br />
        Alaska Health Insurance Premium Payment Program
      </h1>
      <strong>Fill out this form. Then click Submit to send it to us.</strong>
      <p>
        If you prefer to download an Alaska HIPP program Application        
        <a style="color: #064EBA;" lang="en" href="javascript:void(0)" download aria-label="download Alaska HIPP Program Application"
        (click)="openPaperApplication()">download application</a>
      </p>
    </div>
    <div class="col-2"></div>
  </div>
</header>
<br />
<main>
  <app-akform
    [preference]="preference"
    [errorMessageIntialData]="errorMessageIntialData"
    [email]="email"
    [mailingAddress]="mailingAddress"
    [emailTo]="emailTo"
    [faxNo]="faxNo"
    [tollfreeNo]="tollfreeNo"
    [dropingAddress]="dropingAddress"
  ></app-akform>
</main>
<br />
<footer class="text-center bg-light">
  <p>
    Email
    <a
      target="_blank"
      [href]="emailTo"
      alt="Email"
      title="email"
      lang="en"
      style="color: #064EBA"
      >{{ email }}</a
    >
    | Fax {{ faxNo }} | Phone {{ tollfreeNo }} | Mail to {{ mailingAddress }}
  </p>
  <div class="text-dark p-3 bg-secondary bg-opacity-50 bg-gradient">
    HMS, Inc. All Rights Reserved
  </div>
</footer>

<ak-app-scroll-top></ak-app-scroll-top>
